module.exports = __webpack_public_path__ + "img/1250426210.db6be710.jpg";